import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { Link,useNavigate } from "react-router-dom";

const Contact = () => {
  
  return (
    <div>
   <Navbar/>
   <main class="container">
    <section class="contact-section">
     
      <div class="contact-info">
        <h2>Get in Touch</h2>
        <p>We'd love to hear from you! Reach out to us for any inquiries or feedback.</p>
        <ul>
          <li><i class="fas fa-map-marker-alt"></i> 802-Setu Heights, Abrama, Valsad, Guj, India</li>
          <li><i class="fas fa-phone"></i> +91 9725955592</li>
          <li><i class="fas fa-envelope"></i> contact@cloudmindstech.in</li>
        </ul>

        
        <div class="social-connections">
          <h3>Follow Us</h3>
          <ul>
            {/* <li>
              <a href="https://facebook.com" target="_blank" aria-label="Facebook">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" aria-label="Twitter">
                <i class="fab fa-twitter"></i>
              </a>
            </li> */}
            <li>
              <Link to="https://www.instagram.com/cloud_mindstech" target="_blank" aria-label="Instagram">
                <i class="fab fa-instagram"></i>
              </Link>
            </li>
            <li>
              <Link to="https://www.linkedin.com/in/cloudmindstech" target="_blank" aria-label="LinkedIn">
                <i class="fab fa-linkedin-in"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      
      <div class="contact-form">
        <h2>Send Us a Message</h2>
        <form action="#" method="post">
          <input type="text" name="name" placeholder="Your Name" required/>
          <input type="email" name="email" placeholder="Your Email" required/>
          <textarea name="message" placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>
    </section>
  </main>
  <Footer/>
    </div>
  )
}

export default Contact